import BigLightIcon from './component'

export default BigLightIcon
